class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    // Observe changes to the mini-cart content
    const miniCart = document.getElementById('mini-cart');
    if (miniCart) {
      const observer = new MutationObserver(() => {
        // Fetch the cart data and update the free shipping message
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            updateFreeShippingMessage(cart);
          });
      });

      observer.observe(miniCart, { childList: true, subtree: true });
    }

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));

        // Fetch cart data to update free shipping message
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            updateFreeShippingMessage(cart);
          });
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    this.open();

    // Reapply free shipping message logic after rendering
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        updateFreeShippingMessage(cart);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

// Function to update the free shipping message
function updateFreeShippingMessage(cart) {
  //const messageContainer = document.getElementById('free-shipping-message');
  if (!messageContainer) return;

  if (cart.item_count >= 2) {
    messageContainer.innerHTML = `
      <p style="color: green; font-weight: bold; text-align: left;">
        Bundle unlocked! You're saving 10% 🔥
      </p>
    `;
  } else {
    messageContainer.innerHTML = `
    <p style="color: red; font-weight: bold; text-align: left;">
        Add one more item to unlock 10% off!
     </p>
    `;
  
  }
}
